import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api, setAuthToken } from '../api';
import './LoginForm.css';

function RSVPApproval() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [rsvp, setRsvp] = useState(null);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [attending, setAttending] = useState(true);
    //const [guests, setGuests] = useState(0);
    const [plusOneName, setPlusOneName] = useState('');
    const [mealChoice, setMealChoice] = useState('');
    const [dietary_requirements, setDietaryRestrictions] = useState('');
    const [additional_remarks, setMessage] = useState('');
    const [error, setError] = useState(null);
    const [guests, setInputs] = useState([]);
    useEffect(() => {
        const fetchRsvps = async () => {
            // console.log("fetch")
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    setAuthToken(token);
                }
                const response = await api.get(`/api/rsvp/getById/${id}`);
                setRsvp(response.data);
                // console.info(rsvp);
            } catch (err) {
                console.error("Failed to fetch RSVPs:", err);
            }
        };


        fetchRsvps();
    }, [id]);
    if (!rsvp) {
        return <div className="text-center mt-5">Loading RSVP...</div>;
    }
    const Delete = async () => {
        // console.log("fetch")
        try {
            const token = localStorage.getItem('token');
            if (token) {
                setAuthToken(token);
            }
            const response = await api.delete(`/api/rsvp/deleteById/${id}`);
            navigate('/dashboard');
            // console.info(rsvp);
        } catch (err) {
            // console.error("Failed to fetch RSVPs:", err);
        }
    };
    const Approve = async () => {
        // console.log("fetch")
        try {
            const token = localStorage.getItem('token');
            if (token) {
                setAuthToken(token);
            }
            const response = await api.put(`/api/rsvp/updateStatus/${id}`, { status: "Approved" });
            navigate('/dashboard');
            // 
            // const response = await api.get(`/api/rsvp/getById/${id}`);
            // setRsvp(response.data);
            console.info(rsvp);
        } catch (err) {
            console.error("Failed to fetch RSVPs:", err);
        }
    };
    const Save = async () => {
        // console.log("fetch")
        try {
            const token = localStorage.getItem('token');
            if (token) {
                setAuthToken(token);
            }
            const response = await api.put(`/api/rsvp/updateById/${id}`, rsvp);
            setRsvp(response.data);
            // console.info(rsvp);
        } catch (err) {
            // console.error("Failed to fetch RSVPs:", err);
        }
    };
    const handleChange = (e) => {
        setAttending(e.target.attending);  // Update state based on checkbox
    };

    const handleInputChange = (e, id, field) => {
        const value =
            e.target.type === 'checkbox'
                ? e.target.checked
                : e.target.value;

        setRsvp(rsvp => ({
            ...rsvp,
            guests: rsvp.guests.map(guest =>
                guest.id === id
                    ? { ...guest, [field]: value }
                    : guest
            )
        }));
    };

    // Function to add a new set of inputs
    const handleAddInput = () => {
        setRsvp(prev => ({
            ...prev,
            guests: [
                ...prev.guests,
                { id: Date.now(), input1: '', input2: false, input3: '' }
            ]
        }));
    };

    // Function to remove a set of inputs
    const handleRemoveInput = (id) => {
        setRsvp(prev => ({
            ...prev,
            guests: prev.guests.filter(guest => guest.id !== id)
        }));
    };
    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
            <div className="card p-4 shadow rounded-4" style={{ width: '100%' }}>
                <h2 className="text-center mb-4">RSVP</h2>
                <form >
                    <div>
                        <label htmlFor="name" className="form-label">Name</label>
                        <input
                            type="name"
                            className="form-control"
                            id="name"
                            placeholder="Enter Name"
                            value={rsvp.name}
                            onChange={(e) => setRsvp(rsvp => ({ ...rsvp, name: e.target.value }))}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email address</label>

                        <input
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder="Enter email"
                            value={rsvp.email}
                            onChange={(e) => setRsvp(rsvp => ({ ...rsvp, email: e.target.value }))}
                            required
                        />

                    </div>

                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="attending"
                            placeholder="Attending?"
                            checked={rsvp.attending}
                            onChange={(e) => setRsvp(rsvp => ({ ...rsvp, attending: e.target.checked }))}
                        // onChange={(e) => setAttending(e.target.value)}

                        />
                        <label htmlFor="attending" className="form-label">Attending</label>
                    </div>

                    <div>
                        <h3>Guests</h3>
                        {rsvp.guests.map((input, index) => (
                            <div key={input.id} className="form-group row mb-3">

                                {/* Name Input */}
                                <div className="col-12 col-md-6">
                                    <label htmlFor={`input-${input.id}-1`} className="form-label">Name</label>
                                    <input
                                        id={`input-${input.id}-1`}
                                        className="form-control"
                                        type="text"
                                        value={input.input1}
                                        onChange={(e) => handleInputChange(e, input.id, 'input1')}
                                        placeholder="Enter Name"
                                        required
                                    />
                                </div>

                                {/* Child Checkbox */}
                                <div className="col-6 col-md-3 d-flex align-items-center  mt-4">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`input-${input.id}-2`}
                                            checked={input.input2}  // use checked for checkbox
                                            onChange={(e) => handleInputChange(e, input.id, 'input2')}
                                        />
                                        <label htmlFor={`input-${input.id}-2`} className="form-check-label ms-2">
                                            Under 12?
                                        </label>
                                    </div>
                                </div>

                                {/* Remove Button */}
                                <div className="col-6 col-md-3 d-flex justify-content-md-end">
                                    <button
                                        type="button" onClick={() => handleRemoveInput(input.id)} className="btn w-80 mt-4" > Remove </button>

                                </div>

                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={handleAddInput}
                            className="btn btn-primary mb-3"
                        >
                            Add a Guest
                        </button>

                    </div>

                    <div>
                        <label htmlFor="mealChoice" className="form-label">Food restrictions</label>
                        <input
                            type="mealChoice"
                            className="form-control"
                            id="mealChoice"
                            placeholder="Enter any food related restrictions"
                            value={rsvp.dietary_requirements}
                            onChange={(e) => setRsvp(rsvp => ({ ...rsvp, dietary_requirements: e.target.value }))}

                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="message" className="form-label">Message</label>
                        <input
                            type="text"
                            className="form-control"
                            id="message"
                            placeholder="Enter message if you'd like"
                            value={rsvp.additional_remarks}
                            onChange={(e) => setRsvp(rsvp => ({ ...rsvp, additional_remarks: e.target.value }))}
                        />
                    </div>
                    <button type="button" className="btn w-80 m-4" onClick={Approve}>Approve</button>
                    <button type='button' className="btn w-80 m-4" onClick={Delete}>Delete</button>
                    <button type='button' className="btn w-80 m-4" onClick={Save}   >Save</button>
                </form>
            </div>
        </div>
    );
};
export default RSVPApproval;
